import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HighRiskRegistryComponent } from './high-risk-registry.component';

const appRoutes: Routes = [
  {
    path: '',
    component: HighRiskRegistryComponent
  },
  {
    path: ':category',
    component: HighRiskRegistryComponent
  }
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
